export const ADD_SUCCESS = 'Новая группа ЭЗС добавлена';
export const ADD_ERROR = 'Не удалось добавить новую группу ЭЗС';
